import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, BookPlus } from 'lucide-react';
import { useTranslation } from '../context/TranslationContext';
interface AddToGlossaryModalProps {
  isOpen: boolean;
  onClose: () => void;
  suggestedEn: string;
  suggestedFr: string;
}
export const AddToGlossaryModal: React.FC<AddToGlossaryModalProps> = ({
  isOpen,
  onClose,
  suggestedEn,
  suggestedFr
}) => {
  const {
    addGlossaryEntry
  } = useTranslation();
  const [enTerm, setEnTerm] = useState(suggestedEn);
  const [frTerm, setFrTerm] = useState(suggestedFr);
  const [notes, setNotes] = useState('');
  const handleSave = () => {
    addGlossaryEntry({
      english: enTerm,
      french: frTerm,
      notes
    });
    onClose();
  };
  return <AnimatePresence data-id="element-26">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-slate-900/40 z-50 flex items-center justify-center p-4" data-id="element-27">
          
            <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.95,
          opacity: 0
        }} className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden" data-id="element-28">
            
              <div className="p-6 border-b border-slate-100 flex items-start justify-between" data-id="element-29">
                <div className="flex items-center gap-3" data-id="element-30">
                  <div className="w-10 h-10 bg-indigo-50 rounded-full flex items-center justify-center text-indigo-600" data-id="element-31">
                    <BookPlus className="w-5 h-5" data-id="element-32" />
                  </div>
                  <div data-id="element-33">
                    <h3 className="text-lg font-semibold text-slate-900" data-id="element-34">
                      New Term Detected
                    </h3>
                    <p className="text-sm text-slate-500" data-id="element-35">
                      Always use this term in future translations?
                    </p>
                  </div>
                </div>
                <button onClick={onClose} className="text-slate-400 hover:text-slate-600" data-id="element-36">
                
                  <X className="w-5 h-5" data-id="element-37" />
                </button>
              </div>

              <div className="p-6 space-y-4" data-id="element-38">
                <div data-id="element-39">
                  <label className="block text-xs font-medium text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-40">
                    English Source
                  </label>
                  <input type="text" value={enTerm} onChange={e => setEnTerm(e.target.value)} className="w-full px-3 py-2 border border-slate-200 rounded-md text-sm focus:outline-none focus:border-indigo-500" data-id="element-41" />
                
                </div>
                <div data-id="element-42">
                  <label className="block text-xs font-medium text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-43">
                    French Translation
                  </label>
                  <input type="text" value={frTerm} onChange={e => setFrTerm(e.target.value)} className="w-full px-3 py-2 border border-slate-200 rounded-md text-sm focus:outline-none focus:border-indigo-500" data-id="element-44" />
                
                </div>
                <div data-id="element-45">
                  <label className="block text-xs font-medium text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-46">
                    Notes (Optional)
                  </label>
                  <input type="text" value={notes} onChange={e => setNotes(e.target.value)} placeholder="e.g. Use only in SaaS contexts" className="w-full px-3 py-2 border border-slate-200 rounded-md text-sm focus:outline-none focus:border-indigo-500" data-id="element-47" />
                
                </div>
              </div>

              <div className="p-6 bg-slate-50 border-t border-slate-100 flex flex-col gap-2" data-id="element-48">
                <button onClick={handleSave} className="w-full bg-indigo-600 text-white py-2.5 rounded-lg text-sm font-medium hover:bg-indigo-700 transition-colors" data-id="element-49">
                
                  Add to Glossary
                </button>
                <div className="flex gap-2" data-id="element-50">
                  <button onClick={onClose} className="flex-1 bg-white border border-slate-200 text-slate-700 py-2 rounded-lg text-sm font-medium hover:bg-slate-50 transition-colors" data-id="element-51">
                  
                    Skip for now
                  </button>
                  <button onClick={onClose} className="flex-1 bg-white border border-slate-200 text-slate-500 py-2 rounded-lg text-sm font-medium hover:bg-slate-50 transition-colors" data-id="element-52">
                  
                    Never ask
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </>}
    </AnimatePresence>;
};